<template>
  <div class="building-form-row">
    <owal-form-input
      placeholder="Enter your Building Name"
      type="text"
      @input="storeBuildingName($event)"
    />

    <owal-form-input
      placeholder="Enter your Management Group"
      type="text"
      @input="storeManagementGroupName($event)"
    />
  </div>
</template>
<script>
import * as OwalUI from '@/libraries/owal-ui'

export default {
  name: 'BuildingForm',
  methods: {
    storeBuildingName (e) {
      const buildingName = e.target.value
      this.$emit('inputBuildingName', buildingName)
    },
    storeManagementGroupName (e) {
      const managementGroup = e.target.value
      this.$emit('inputManagementGroup', managementGroup)
    },
  },
  components: {
    ...OwalUI,
  },
}
</script>
<style>
.building.name.form {
  display: flex;
  justify-content: space-between;
}

.building-form-row {
  display: flex;
  flex-direction: row;
}
.field.left {
  margin-right: 3px;
}
</style>
